import * as Tooltip from '~/components/ui/Tooltip';

export function formatNumber(numberToFormat: number) {
  return new Intl.NumberFormat(navigator.language).format(numberToFormat);
}

export function formatTokens(count: number | undefined): string {
  if (typeof count === 'undefined') {
    return '';
  }

  const { value, unit = '' } = formatTokensNumber(count);

  return `${value}${unit}`;
}

export function formatTokensFullText(count: number) {
  const { value, unit } = formatTokensNumber(count);

  switch (unit) {
    case 'M': {
      return `${value} Million`;
    }
    case 'K': {
      return `${value} Thousand`;
    }
    default: {
      return value;
    }
  }
}

export function formatTokensNumber(count: number) {
  if (count >= 1_000_000) {
    let fixed = (count / 1_000_000).toFixed(1);

    // remove '.0'
    if (fixed.endsWith('.0')) {
      fixed = fixed.slice(0, -2);
    }

    return { value: fixed, unit: 'M' as const };
  }

  if (count >= 1_000) {
    return { value: Math.floor(count / 1_000), unit: 'K' as const };
  }

  return { value: count };
}

export function formatSeats(quantity: number) {
  return `${quantity} seat${quantity > 1 ? 's' : ''}`;
}

export function formatMemberEmails(emails: string[]) {
  const VISIBLE_EMAILS = 5;

  const visible = (
    <span className="flex flex-wrap justify-end gap-1">
      {emails.slice(0, VISIBLE_EMAILS).map((email, i) => (
        <>
          <span className="text-nowrap truncate" key={i}>
            {email}
            {i !== Math.min(emails.length, VISIBLE_EMAILS) - 1 && ','}
          </span>
        </>
      ))}
    </span>
  );

  if (emails.length <= VISIBLE_EMAILS) {
    return visible;
  }

  const hidden = emails.slice(VISIBLE_EMAILS);
  const count = hidden.length;

  return (
    <>
      {visible}
      <Tooltip.Provider>
        <Tooltip.Root delayDuration={300}>
          <Tooltip.Trigger asChild>
            <span>
              {' '}
              and {count} more <span className="inline-block i-ph:info-bold text-bolt-elements-icon-info text-sm" />
            </span>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content sideOffset={3}>
              {hidden.join(', ')}
              <Tooltip.Arrow />
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    </>
  );
}
